<template>
    <div>
        <div class="tabs is-boxed">
            <ul>
                <router-link
                    tag="li"
                    :to="{ name: 'client-content-strings', params: { clientId: clientId } }"
                    active-class="is-active"
                >
                    <a>Strings</a>
                </router-link>
                <router-link
                    tag="li"
                    :to="{ name: 'client-content-links', params: { clientId: clientId } }"
                    active-class="is-active"
                >
                    <a>Links</a>
                </router-link>
            </ul>
        </div>

        <div>
            <router-view />
        </div>
    </div>
</template>
<script>
export default {
    name: 'client-content',
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/content/index.vue